import {
  FETCH_BOOKING_DISCOUNT,
  FETCH_BOOKING__DISCOUNT_SUCCESS,
  FETCH_BOOKING__DISCOUNT_FAILED,
} from "../store/types";
import {
  cloud_function_server_url,
} from '../../config';

const END_POINT = `${cloud_function_server_url}/booking`;


export const fetchEarningsReport = () => (dispatch) => (firebase) => {

  const {
    bookingRef
  } = firebase;

  dispatch({
    type: FETCH_BOOKING_DISCOUNT,
    payload: null
  });

  fetch(`${END_POINT}/fetch-bookings`, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
})
    .then(async (res) => {
        const response = await res.json();
        const mainArr = response?.data

        var monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var renderobj = {};
        mainArr.map(item => {
          if ((item.status === 'PAID' || item.status === 'COMPLETE') && item.discount_amount !== undefined && item.driver_share !== undefined && item.customer_paid !== undefined && item.convenience_fees !== undefined && item.trip_cost !== undefined) {
  
            let bdt = new Date(item.tripdate);
            let uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth();
            if (renderobj[uniqueKey]) {
              renderobj[uniqueKey].discountAmount = parseFloat(renderobj[uniqueKey].discountAmount) + parseFloat(item.discount_amount);
              renderobj[uniqueKey].driverShare = parseFloat(renderobj[uniqueKey].driverShare) + parseFloat(item.driver_share);
              renderobj[uniqueKey].customerPaid = parseFloat(renderobj[uniqueKey].customerPaid) + parseFloat(item.customer_paid);
              renderobj[uniqueKey].convenienceFee = parseFloat(renderobj[uniqueKey].convenienceFee) + parseFloat(item.convenience_fees);
              renderobj[uniqueKey].tripCost = parseFloat(renderobj[uniqueKey].tripCost) + parseFloat(item.trip_cost);
  
            } else {
              renderobj[uniqueKey] = {};
              renderobj[uniqueKey]['dated'] = item.tripdate;
              renderobj[uniqueKey]['year'] = bdt.getFullYear();
              renderobj[uniqueKey]['month'] = bdt.getMonth();
              renderobj[uniqueKey]['monthsName'] = monthsName[bdt.getMonth()];
              renderobj[uniqueKey]['discountAmount'] = parseFloat(item.discount_amount);
              renderobj[uniqueKey]['driverShare'] = parseFloat(item.driver_share);
              renderobj[uniqueKey]['customerPaid'] = parseFloat(item.customer_paid);
              renderobj[uniqueKey]['convenienceFee'] = parseFloat(item.convenience_fees);
              renderobj[uniqueKey]['uniqueKey'] = uniqueKey;
              renderobj[uniqueKey]['tripCost'] = parseFloat(item.trip_cost);
  
            }
          }
          return null;
        });
        if (renderobj) {
          const arr = Object.keys(renderobj).map(i => {
            renderobj[i].myEarning = parseFloat(renderobj[i].customerPaid - renderobj[i].driverShare).toFixed(2);
            renderobj[i].customerPaid = parseFloat(renderobj[i].customerPaid).toFixed(2);
            renderobj[i].rideCost = parseFloat(renderobj[i].tripCost - renderobj[i].convenienceFee).toFixed(2);
            renderobj[i].driverShare = parseFloat(renderobj[i].driverShare).toFixed(2);
            return renderobj[i]
          })
          dispatch({
            type: FETCH_BOOKING__DISCOUNT_SUCCESS,
            payload: arr
          });
        }

    }).catch(error => {
        console.log("FETCH_BOOKING__DISCOUNT_FAILED", error)
        dispatch({
          type: FETCH_BOOKING__DISCOUNT_FAILED,
          payload: "No data available."
        });
    });
};

